$( document ).ready(function() {
  
 // $('.top-relted-wrap').wrapAll('<div class="custom-wrap-custm-sect"></div>');

$('.custom-wrap-custm-sect').each(function() {
    $(this).appendTo('.top-relted-wrap');
      
  });


 $('.range-slider').slick({ 
  arrows: true,
  dots: true, 
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      } 
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
});



 $('.featured-clctn.product-grid').slick({ arrows: true,
  dots: true, 
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      } 
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
});

});


$( document ).ready(function() {
 $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });




  $(".cross-icon i").click(function(){
  $("#Details-HeaderMenu-1").removeAttr("open");
});
  
// Close menu on click
$(".menu ul").on("click", "li", function() {
  $("#toggle").click();
});

// toggle open/close mobile navigation (Main and sidebar)
$(document).ready(function() {
  $('#toggle').click(function(e) {
    e.stopPropagation();
  });
  $('html').click(function(e) {
    if (!$('.toggle').is($(e.target))) {
      $('#toggle').prop("checked", false);
    }
  });
});

});


$( document ).ready(function() {
  setTimeout(function() {
$('.custom-slider-cls2').slick({ 
  arrows: true,
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
    
});
 }, 1000);

});


$(document).ready(function(){ 
    $('.tab-a').click(function(){  
      $(".tab").removeClass('tab-active');
      $(".tab[data-id='"+$(this).attr('data-id')+"']").addClass("tab-active");
      $(".tab-a").removeClass('active-a');
      $(this).parent().find(".tab-a").addClass('active-a');
  
     });

  
});
  
 
$(window). scroll(function() {
var scroll = $(window). scrollTop();
if (scroll >= 60) {
$('sticky-header'). addClass("fixed_header_vg");
} else {
$('sticky-header'). removeClass("fixed_header_vg");
}
});

//$('button.shopify-payment-button__more-options').text('Buy Now');

// $(document).ready(function(){
//     $('.filter_text').click(function(){
//       $('.collection_titles').toggle();
//     });
// })

 
  
// $(document).ready(function() {
//   $(".buy-now-btn").click(function() {
//     // Trigger a click on the "Add to Cart" button if it exists
//     var addToCartButton = $(".product-form__submit");
//     if (addToCartButton.length) {
//       addToCartButton.click();
//     } else {
//       console.error("Add to Cart button not found");
//     }
//     // Redirect to the checkout page (replace with your actual checkout URL)
//     window.location.href = "/checkout/";
//   });
// });


// $(document).ready(function () {
// // Get the select element and wrap all options in a div
// $('#SortBy option').wrapAll('<div class="cstm-opt"></div>');
// });

$(document).ready(function () {
// Get the select element and wrap all options in a div
$('#wcp-30-open span').text('Pago por transferencia');
$('#wpd-cart-drawer-checkout span').text('Otras opciones de pago');
$('#cart_drawer_title').text('Carrito Wholesale');
$('#wpd_welcome_message_container h4').text('');
});

